module.exports = __webpack_public_path__ + "static/media/blog-img4.5c1f6a95.jpg";